import { useCallback, useReducer } from 'react';

export default function useModal() {
  return useReducer(
    useCallback((state) => !state, []),
    false,
  );
}
